export default __webpack_public_path__ + "static/media/tag-black.5226fe7e.svg";